import * as React from 'react';

import { EditableTargetingCloud, EditableTargetingCloudProps } from '../EditableTargetingCloud/EditableTargetingCloud';

export const TargetingTextEditor: React.FC<EditableTargetingCloudProps> = React.memo(props => {
    return <EditableTargetingCloud {...props} isEditable={true} />;
});
